import { useMutation } from '@apollo/client';
import { useRouter } from 'next/router';
import { v4 as uuidv4 } from 'uuid';
import { ANALYTICS_CREATE } from '../graphql/mutations';

// eslint-disable-next-line no-shadow
export enum Action {
  CLICK = 'click',
  SIGN_UP = 'signUp',
  SIGN_IN = 'signIn',
  SIGN_OUT = 'signOut',
  PASSWORD_RESET = 'passwordReset',
  PAGE_VIEW = 'pageView'
}

// eslint-disable-next-line no-shadow
export enum Category {
  USER_EVENT = 'userEvent'
}

// eslint-disable-next-line no-shadow
export enum AccessLevel {
  REGISTRATION = 'registration',
  RESTRICTED = 'restricted',
  OPEN = 'open'
}

export interface Event {
  action: Action;
  category: Category;
  data: {
    id: string; // uuid
    sessionId: string; // session storage session id
    path: string; // url path
    event: string;
  };
  user: {
    id: String;
    fName: String;
    lName: String;
    email: String;
    accessLevel: String;
  };
}

export const useAnalytics = (customPathParser?) => {
  // const { log } = useContext(LogDispatchContext);
  const router = useRouter();
  const [updateAnalytics] = useMutation(ANALYTICS_CREATE, {});

  // log.debug({ source: 'analyticsLib', action: 'AnalyticsLib:Init', data: { parser: customPathParser } });

  function getEvent() {
    let path: any = router.asPath.split('#');
    path = path.length > 1 ? path[1] : path[0];

    const [, conferenceSlug, eventSlug, additionalSlug] = path.split('/');

    if (conferenceSlug === 'login?page=') {
      return `${eventSlug}/${additionalSlug}`;
    }
    return `${conferenceSlug}/${eventSlug}`;
  }

  function getSlug() {
    let path: any = router.asPath.split('#');
    path = path.length > 1 ? path[1] : path[0];

    const [, conferenceSlug, eventSlug, additionalSlug] = path.split('/');

    if (conferenceSlug === 'login?page=') {
      return 'login';
    }
    return path.substring(path.indexOf(additionalSlug));
  }

  // TODO: Drew to complete
  const sendAnalytics = async (
    action?: Action,
    category?: Category,
    actionID?: string,
    eventDetails?: any,
    user?: any
  ) => {
    // log.debug({ source: 'analyticsLib', action: 'AnalyticsLib:PathParams', data: { parser: customPathParser } });

    // console.log(' :: ');

    const evt: Event = {
      action,
      category,
      data: {
        id: actionID,
        sessionId: '', // TODO, where to get this
        path: getSlug(),
        event: getEvent()
      },
      user
    };

    try {
      // log.debug({ source: 'analyticsLib', action: 'AnalyticsLib:UpdateAnalytics', data: evt });
      await updateAnalytics({
        variables: {
          input: evt
        }
      });
    } catch (error) {
      // log.error({ source: 'analyticsLib', action: 'AnalyticsLib:Error', data: error });
    }
  };

  const logEvent = async ({ action, params }) => {
    // @ts-ignore
    window.gtag('event', action, params);
  };

  return Object.freeze({
    sendAnalytics: (action: Action, category?: Category, actionID?: string, eventDetails?: any, user?: any) =>
      sendAnalytics(action, category, actionID, eventDetails, user),
    logEvent: ({ action, params }) => logEvent({ action, params })
  });
};
